// Layer 3 (Transformation): one derivation of the missing-sample runs in a
// reading series, shared by every surface that draws an outage as a gap rather
// than joining across it — the bearing case page's handoff trend (W3d) and the
// Maintenance condition detail's BM01 trend (W3e, #650). Pure: no React, no
// engine mutation.
//
// A gap is the span between the last observed sample before a run of nulls and
// the first observed sample after it, so both ends land on measurements the
// line actually draws from. A run with no sample before it is not a gap — the
// series simply starts there. This is the case page's own rule, lifted
// unchanged so the two surfaces cannot drift.

import type { SeriesTime } from '@/versions/v1/schema/reading-series';

/** The minimum a point must carry to be read for gaps. `value: null` marks a
 *  sample the historian did not record — a trip, a comms loss, a missed run. */
export type SeriesGapPoint = { at: SeriesTime; value: number | null };

/** A run of missing samples, bounded by the observed samples either side. */
export type SeriesGap = { startAt: SeriesTime; endAt: SeriesTime };

/** Missing-sample runs inside the window, drawn from the last sample before to
 *  the first after. */
export function sampleGaps(points: readonly SeriesGapPoint[]): SeriesGap[] {
  const gaps: SeriesGap[] = [];
  let lastSeen: SeriesTime | null = null;
  let open = false;
  for (const point of points) {
    if (point.value === null) {
      if (lastSeen) open = true;
      continue;
    }
    if (open && lastSeen) gaps.push({ startAt: lastSeen, endAt: point.at });
    open = false;
    lastSeen = point.at;
  }
  return gaps;
}
